<template>
	<div class="d-flex">
		<div class="page pa-1 flex-grow-1" @click="clickHandler">
			<span>{{index + 1}}</span>
		</div>
		<v-btn
			icon
			v-on:click="deletePage(data['pageID'])"
			:loading="deleteInAction"
			v-if="canBeDeleted"
		>
			<v-icon title="Šalinti puslapį">mdi-close</v-icon>
		</v-btn>
	</div>
</template>

<script>
	import AtlasHelper from "../helpers/AtlasHelper";

	export default {
		props: {
			data: Object,
			atlasId: String,
			refreshAtlasPagesList: Function,
			clickHandler: Function,
			canBeDeleted: Boolean,
			index: Number
		},
		data: function(){
			var data = {
				deleteInAction: false
			};
			return data;
		},
		methods: {
			deletePage: function(pageId){
				var e = {
					title: "Ar tikrai šalinti puslapį?",
					message: "Ar tikrai šalinti puslapį? Pašalinus puslapį jo atstatyti nebeįmanoma!",
					positiveActionTitle: "Šalinti puslapį",
					negativeActionTitle: "Atšaukti",
					positive: function(){
						this.deleteInAction = true;
						AtlasHelper.deletePage(this.atlasId, pageId).then(function(){
							this.refreshAtlasPagesList();
							this.deleteInAction = false;
						}.bind(this), function(){
							this.$vBus.$emit("show-message", "error");
							this.deleteInAction = false;
						}.bind(this));
					}.bind(this)
				};
				this.$vBus.$emit("confirm", e);
			}
		}
	};
</script>

<style scoped>
	.page {
		border: 1px solid #c7c7c7;
		cursor: pointer;
	}
	.active-page .page {
		border: 1px solid green;
		background-color: #e9ffe9;
		pointer-events: none;
	}
</style>